import { toast } from "react-toastify";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllStudentChapters({ payload }) {
  try {
    yield put(actions.addStudentChapterLoading(true));
    const result = yield call(api.getAllStudentChapters);
    yield put(actions.getAllStudentChaptersSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getAllStudentChaptersFail());
  } finally {
    yield put(actions.addStudentChapterLoading(false));
  }
}

function* getStudentChapters({ payload }) {
  try {
    yield put(actions.addStudentChapterLoading(true));
    const result = yield call(api.getStudentChapters);
    yield put(actions.getStudentChaptersSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getStudentChaptersFail());
  } finally {
    yield put(actions.addStudentChapterLoading(false));
  }
}

function* getAllChapters({ payload }) {
  try {
    yield put(actions.addStudentChapterLoading(true));
    const result = yield call(api.getAllChapters, payload);
    yield put(actions.getAllChaptersSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getAllChaptersFail());
  } finally {
    yield put(actions.addStudentChapterLoading(false));
  }
}

function* getChapterContent({ payload: chapterId }) {
  try {
    const result = yield call(api.getChapterContent, chapterId);
    const raw = result.data || {};
    const body = raw.data != null && typeof raw.data === "object" ? raw.data : raw;
    yield put(
      actions.getChapterContentSuccess({
        chapterId,
        videos: body.videos,
        lessons: body.lessons,
        exams: body.exams,
        live_videos: body.live_videos,
        homeworks: body.homeworks,
      })
    );
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Could not load lesson content";
    toast.error(msg);
    yield put(
      actions.getChapterContentFail({
        chapterId,
        error: msg,
      })
    );
  }
}

export default function* StudentChapter() {
  yield takeLatest(Types.GET_STUDENT_CHAPTERS_REQUEST, getAllStudentChapters);
  yield takeLatest(Types.GET_ALL_STUDENT_CHAPTERS_REQUEST, getStudentChapters);
  yield takeLatest(Types.GET_ALL_CHAPTERS_REQUEST, getAllChapters);
  yield takeEvery(Types.GET_CHAPTER_CONTENT_REQUEST, getChapterContent);
}
